<template>
 <div class="d-flex w-full justify-content-center" v-if="params.value!=='-'&&params.value !== null&&params.value !== undefined ">
    {{ date }}
  </div>
  <div v-else class="d-flex w-full justify-content-center">
 <p>-</p>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      // date: new Date()
    };
  },
  mounted() {
    // this.date = moment(this.params.value).format("DD/MM/YYYY");
  },
  methods: {},
   computed: {
    date() {
      return this.params.value !== null || this.params.value !== null ? 
      moment(this.params.value).format("DD/MM/YYYY")
      :"-"
    }
  },
};
</script>
